/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MerchantBrandSize = {
    LOCAL: 'LOCAL',
    REGIONAL: 'REGIONAL',
    NATIONAL: 'NATIONAL'
} as const;
export type MerchantBrandSize = typeof MerchantBrandSize[keyof typeof MerchantBrandSize];


export function instanceOfMerchantBrandSize(value: any): boolean {
    for (const key in MerchantBrandSize) {
        if (Object.prototype.hasOwnProperty.call(MerchantBrandSize, key)) {
            if (MerchantBrandSize[key as keyof typeof MerchantBrandSize] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MerchantBrandSizeFromJSON(json: any): MerchantBrandSize {
    return MerchantBrandSizeFromJSONTyped(json, false);
}

export function MerchantBrandSizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MerchantBrandSize {
    return json as MerchantBrandSize;
}

export function MerchantBrandSizeToJSON(value?: MerchantBrandSize | null): any {
    return value as any;
}

export function MerchantBrandSizeToJSONTyped(value: any, ignoreDiscriminator: boolean): MerchantBrandSize {
    return value as MerchantBrandSize;
}

